module.exports = __webpack_public_path__ + "static/engineer_icon-424091b68eb2d952c7b403606bab9184.png";